import { useDispatch } from "react-redux";
import { importFromYaml } from "../../../../abstract/controller/modelYamlImport";
import * as tutorialUtils from "../../../../abstract/controller/utils/tutorialUtils";
import { setRoot } from "../../../../abstract/redux/slice/structureSlice";
import ButtonIntroWide from "../../../ui/buttons/ButtonIntroWide";
import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import styles from "./Manual.module.scss";

const id = "dNT7";
const idNext = "dNT8";
const idPrev = "dNT6";

const next = `
functions:
  - function: Demo
    parameters:
      - parameter: Exclusion_Service
        choices:
          - choice: AllGames
          - choice: AllLottery
          - choice: AllSports
          - choice: Lotto
          - choice: Vikinglotto
          - choice: Eurojackpot
          - choice: Extra
          - choice: Joker
          - choice: Keno
          - choice: Nabolaget
          - choice: Tipping
          - choice: Oddsbomben
      - parameter: Pause_Options
        choices:
          - choice: SpillePause
          - choice: Utestegning
      - output parameter: reminder_lotto
        default value: på
      - output parameter: reminder_vikinglotto
        default value: på
      - output parameter: reminder_eurojackpot
        default value: på
      - output parameter: reminder_extra
        default value: på
      - output parameter: reminder_joker
        default value: på
      - output parameter: reminder_keno
        default value: på
      - output parameter: nudge_balance
        default value: av
      - output parameter: nudge_round
        default value: av
      - output parameter: COUPON
        default value: active
    logic:
      - assignment: Set reminder - LOTTO
        expression: "'Exclusion_Service' IN ['AllGames', 'AllLottery', 'Lotto']  =>
          'reminder_lotto' = 'av'"
      - assignment: Set reminder - VIKINGLOTTO
        expression: "'Exclusion_Service' IN ['AllGames', 'AllLottery', 'Vikinglotto'] =>
          'reminder_vikinglotto' = 'av'"
      - assignment: Set reminder - EUROJACKPOT
        expression: "'Exclusion_Service' IN ['AllGames', 'AllLottery', 'Eurojackpot'] =>
          'reminder_eurojackpot' = 'av'"
      - assignment: Set reminder - EXTRA
        expression: "'Exclusion_Service' IN ['AllGames', 'AllLottery', 'Extra'] =>
          'reminder_extra' = 'av'"
      - assignment: Set reminder - JOKER
        expression: "'Exclusion_Service' IN ['AllGames', 'AllLottery', 'Joker'] =>
          'reminder_joker' = 'av'"
      - assignment: Set reminder - KENO
        expression: "'Exclusion_Service' IN ['AllGames', 'AllLottery', 'Keno'] =>
          'reminder_keno' = 'av'"
      - assignment: Set nudge - BALANCE
        expression: "'Exclusion_Service' IN ['Nabolaget'] => 'nudge_balance' = 'på'"
      - assignment: Set nudge - ROUND
        expression: "'Exclusion_Service' IN ['Nabolaget'] => 'nudge_round' = 'på'"
      - assignment: Set COUPON
        expression: "'Exclusion_Service' IN ['Tipping', 'Oddsbomben'] => 'COUPON' =
          'expired'"
`;

const prev = `
functions:
  - function: Demo
    parameters:
      - parameter: Exclusion_Service
        choices:
          - choice: AllGames
          - choice: AllLottery
          - choice: AllSports
          - choice: Lotto
          - choice: Vikinglotto
          - choice: Eurojackpot
          - choice: Extra
          - choice: Joker
          - choice: Keno
          - choice: Nabolaget
          - choice: Tipping
          - choice: Oddsbomben
      - parameter: Pause_Options
        choices:
          - choice: SpillePause
          - choice: Utestegning
      - output parameter: reminder_lotto
        default value: på
`;

function ManualDedicatedNorskTipping7({ tutorial, setTutorial }) {
  if (tutorial === id) {
    return <Core setTutorial={setTutorial} />;
  }

  return null;
}

function Core({ setTutorial }) {
  const _dispatch = useDispatch();

  const handleShowMe = () => {
    const { model } = importFromYaml(next);
    _dispatch(setRoot(model, 0));
  };

  const handleBack = () => {
    const { model } = importFromYaml(prev);
    _dispatch(setRoot(model, 0));
    setTutorial(idPrev);
  };

  const handleClose = () => {
    setTutorial("null");
  };

  return (
    <>
      <div className={`${styles["foreground"]} ${styles["foreground-dnt7"]}  ${styles["overlay"]}`}>
        <ButtonTomatoClose onClick={handleClose} />
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            <p>
              Great! Not, let's add a few more output parameters and assignments to complete the
              model. Please click on the <b>Complete</b> button below.
            </p>
          </div>
        </div>
        <div className={styles["confirmation"]}>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="red" title="Go back!" onClick={handleBack} />
          </div>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="tomato" title="Complete!" onClick={handleShowMe} />
          </div>
        </div>
      </div>
    </>
  );
}

export const manualValidateDedicatedNorskTipping7 = (root, tutorial, setTutorial, setMessage) => {
  if (tutorial === id) {
    let { res: resFun, msg: msgFun } = tutorialUtils.validateSingleFunction(root, "Demo");

    if (!resFun) {
      setMessage(msgFun)
      return false;
    }

    let { res: resOut, msg: msgOut } = tutorialUtils.validateParametersOutput(root, false, [
      "reminder_lotto",
      "reminder_vikinglotto",
      "reminder_eurojackpot",
      "reminder_extra",
      "reminder_joker",
      "reminder_keno",
      "nudge_balance",
      "nudge_round",
      "COUPON",
    ]);

    if (!resOut) {
      setMessage(msgOut)
      return false;
    }

    let { res: resA, msg: msgA } = tutorialUtils.validateLogicExpression(
      root,
      "Set reminder - LOTTO",
      "'Exclusion_Service' IN ['AllGames', 'AllLottery', 'Lotto']  => 'reminder_lotto' = 'av'",
    );

    if (!resA) {
      setMessage(msgA)
      return false;
    }

    let { res: resB, msg: msgB } = tutorialUtils.validateLogicExpression(
      root,
      "Set reminder - VIKINGLOTTO",
      "'Exclusion_Service' IN ['AllGames', 'AllLottery', 'Vikinglotto'] => 'reminder_vikinglotto' = 'av'",
    );

    if (!resB) {
      setMessage(msgB)
      return false;
    }

    let { res: resC, msg: msgC } = tutorialUtils.validateLogicExpression(
      root,
      "Set reminder - EUROJACKPOT",
      "'Exclusion_Service' IN ['AllGames', 'AllLottery', 'Eurojackpot'] => 'reminder_eurojackpot' = 'av'",
    );

    if (!resC) {
      setMessage(msgC)
      return false;
    }

    let { res: resD, msg: msgD } = tutorialUtils.validateLogicExpression(
      root,
      "Set reminder - EXTRA",
      "'Exclusion_Service' IN ['AllGames', 'AllLottery', 'Extra'] => 'reminder_extra' = 'av'",
    );

    if (!resD) {
      setMessage(msgD)
      return false;
    }

    let { res: resE, msg: msgE} = tutorialUtils.validateLogicExpression(
      root,
      "Set reminder - JOKER",
      "'Exclusion_Service' IN ['AllGames', 'AllLottery', 'Joker'] => 'reminder_joker' = 'av'",
    );

    if (!resE) {
      setMessage(msgE)
      return false;
    }

    let { res: resF, msg: msgF } = tutorialUtils.validateLogicExpression(
      root,
      "Set reminder - KENO",
      "'Exclusion_Service' IN ['AllGames', 'AllLottery', 'Keno'] => 'reminder_keno' = 'av'",
    );

    if (!resF) {
      setMessage(msgF)
      return false;
    }

    let { res: resG, msg: msgG } = tutorialUtils.validateLogicExpression(
      root,
      "Set nudge - BALANCE",
      "'Exclusion_Service' IN ['Nabolaget'] => 'nudge_balance' = 'på'",
    );

    if (!resG) {
      setMessage(msgG)
      return false;
    }

    let { res: resH, msg: msgH } = tutorialUtils.validateLogicExpression(
      root,
      "Set nudge - ROUND",
      "'Exclusion_Service' IN ['Nabolaget'] => 'nudge_round' = 'på'",
    );

    if (!resH) {
      setMessage(msgH)
      return false;
    }

    let { res: resI, msg: msgI } = tutorialUtils.validateLogicExpression(
      root,
      "Set COUPON",
      "'Exclusion_Service' IN ['Tipping', 'Oddsbomben'] => 'COUPON' = 'expired'",
    );

    if (!resI) {
      setMessage(msgI)
      return false;
    }

    setTutorial(idNext);

    setMessage("")
    return true;
  }

  return false;
};

export default ManualDedicatedNorskTipping7;
